import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "collapsed-export-item-record" }
const _hoisted_2 = { class: "collapsed-export-item-record__label" }
const _hoisted_3 = { class: "collapsed-export-item-record__value" }


export default /*#__PURE__*/_defineComponent({
  __name: 'CollapsedExportItemRecord',
  props: {
  label: { type: String, required: true },
  value: { type: String, required: true },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.label) + ":", 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.value), 1)
  ]))
}
}

})